import Skeleton from 'components/Skeleton/Skeleton'
import React, { MutableRefObject } from 'react'
import CurrencyInput from 'react-currency-input-field'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> { loading?: boolean, inputRef?: MutableRefObject<any>, rest?: any, onValueChange?: any, suffix?: string }

function InputMoney ({ inputRef, className, onChange, loading, suffix, ...rest }: InputProps) {
  return (
    loading
      ? <Skeleton />
      : <CurrencyInput
      {...(rest as any)}
      ref={inputRef}
      prefix="R$ "
      suffix={suffix}
      onValueChange={onChange}
      className={className ? className : 'ant-input'}
      decimalsLimit={2}
      decimalSeparator=","
      groupSeparator="."
      onInput={(e:any) => {
        const value = (e.target as HTMLInputElement).value
        const numericalValue = Number(value.match(/[\d^,]/gi)?.join(''))
        const fractionalValue = value.match(/,\d+$/gi)?.join('') || ''
        if (numericalValue > 999999999 || fractionalValue.length > 3) {
          (e.target as HTMLInputElement).value = value.slice(0, -1)
        }
      }}
    />
  )
}

export default InputMoney
